export const TEMPLATE_LIVE_VIEW_PREFIX =
  'https://www.wix.com/marketplace/template/view/live';
